import * as r from "react";
import t from "../lib/IconBase.es.js";
import m from "../defs/TrayArrowUp.es.js";
const o = r.forwardRef((a, e) => /* @__PURE__ */ r.createElement(t, { ref: e, ...a, weights: m }));
o.displayName = "TrayArrowUpIcon";
const s = o;
export {
  s as TrayArrowUp,
  o as TrayArrowUpIcon
};
